<template lang="pug">
  .profile-card
    .profile__title
      h1.title Редактирование учетной записи
    .profile__content
      form.profile-page-form
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Общая информация
          .profile-section__bod
            operators-create-form

</template>
<script>
import OperatorsCreateForm from "./components/operators-edit-form.vue";

export default {
  components: {
    OperatorsCreateForm,
  },
  name: "admin-operators-edit",
};
</script>
